import React, { Component } from 'react';
import PropTypes from 'prop-types';
import history from '../../utils/history';
import { handleLogout } from '../../utils/api';
import cookieLib from '../../helpers/cookieLib';
class Logout extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    // this.checkFocus = this.checkFocus.bind(this);
    // this.checkAgain = this.checkAgain.bind(this);
  }

  componentDidMount() {
    // this.timer = setTimeout(this.checkFocus, 4000);
    const cid = cookieLib.getCookieByKey('cid');
    const token = cookieLib.getCookieByKey('token');
    if (
      (history.location.state && !history.location.state.apiCall) ||
      (!cid && !token)
    ) {
      handleLogout();
    } else {
      this.props.logout();
    }
  }

  // componentWillUnmount() {
  //   // clearTimeout(this.timer);
  //   // window.removeEventListener('onfocus');
  // }

  // checkAgain() {
  //   if (document.hasFocus()) {
  //     handleLogout();
  //   }
  // }

  // checkFocus() {
  //   window.addEventListener('onfocus', this.checkAgain);
  // }

  render() {
    const msg =
      (history.location.state && history.location.state.message) || '';
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {msg}Logging you out...
      </div>
    );
  }
}
Logout.propTypes = {
  logout: PropTypes.func,
};

export default Logout;
